import SectionHeading from '@/components/feature/SectionHeading';
import { collections } from '@/mocks/home';

export default function Collections() {
  return (
    <section id="collections" className="w-full bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="Collection"
          title="短剧大合集：口味相近的延伸片单"
          desc="看完《欲望的诱惑》意犹未尽时，可以顺着这些题材相近的短剧继续浏览，它们同样以快节奏与反转见长。"
        />

        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {collections.map((c) => (
            <article
              key={c.title}
              className="group rounded-lg border border-background-200 bg-background-50 overflow-hidden flex flex-col"
            >
              <div className="w-full h-44 md:h-52 overflow-hidden">
                <img
                  src={c.cover}
                  alt={`短剧大合集 ${c.title} 封面`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-3 md:p-4 flex-1 flex flex-col">
                <span className="w-fit px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-[11px] font-label">
                  {c.tag}
                </span>
                <h3 className="mt-2 font-heading text-sm md:text-base font-bold text-foreground-950">{c.title}</h3>
                <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}